import { useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const headlineSx = {
  position: 'absolute' as const,
  color: '#fff',
  fontWeight: 600,
  pointerEvents: 'none' as const,
  display: { xs: 'none', md: 'block' },
  zIndex: 2,
  textShadow: '0 2px 16px rgba(0, 0, 0, 0.3)',
};

function TypewriterText({
  text,
  delayMs = 0,
  speedMs = 56,
}: {
  delayMs?: number;
  speedMs?: number;
  text: string;
}) {
  const [visibleChars, setVisibleChars] = useState(0);

  useEffect(() => {
    setVisibleChars(0);

    const startTimer = window.setTimeout(() => {
      const intervalId = window.setInterval(() => {
        setVisibleChars(prev => {
          if (prev >= text.length) {
            window.clearInterval(intervalId);
            return prev;
          }
          return prev + 1;
        });
      }, speedMs);
    }, delayMs);

    return () => {
      window.clearTimeout(startTimer);
    };
  }, [delayMs, speedMs, text]);

  return (
    <Box component="span" sx={{ display: 'inline' }}>
      {text.slice(0, visibleChars)}
      {visibleChars < text.length ? (
        <Box
          component="span"
          sx={{
            display: 'inline-block',
            width: '0.08em',
            height: '0.95em',
            ml: '0.08em',
            verticalAlign: '-0.08em',
            backgroundColor: 'rgba(255,255,255,0.92)',
            animation: 'login-copy-caret 0.9s step-end infinite',
            '@keyframes login-copy-caret': {
              '0%, 45%': { opacity: 1 },
              '46%, 100%': { opacity: 0 },
            },
          }}
        />
      ) : null}
    </Box>
  );
}

export function LoginMarketingCopy() {
  return (
    <>
      <Typography
        sx={{
          ...headlineSx,
          left: { md: 32, lg: 56 },
          top: { md: '32%', lg: '34%' },
          maxWidth: 273,
          fontSize: 28,
          lineHeight: '37px',
        }}
      >
        <TypewriterText text="Build beautiful spaces, seamlessly." delayMs={120} speedMs={48} />
      </Typography>
      <Typography
        sx={{
          ...headlineSx,
          right: { md: 32, lg: 48 },
          top: { md: 48, lg: 68 },
          maxWidth: 358,
          fontSize: 26,
          lineHeight: '34px',
        }}
      >
        <TypewriterText
          text="Create, manage and share your FF&E proposals."
          delayMs={700}
          speedMs={50}
        />
      </Typography>
      <Typography
        sx={{
          ...headlineSx,
          right: { md: 32, lg: 48 },
          bottom: { md: 24, lg: 32 },
          maxWidth: 220,
          fontSize: 18,
          lineHeight: '24px',
        }}
      >
        <TypewriterText text="Manage your projects with clarity." delayMs={1400} speedMs={52} />
      </Typography>
    </>
  );
}
